import React from 'react';
import styled from 'styled-components';
import { DataElementContext } from '@/page-components/common/DataElementContext';
import { useAppDispatch, useAppSelector } from '@/store';
import ClientDetection from '@/modules/casino/utils/ClientDetection';
import { connectAppNotification } from '@/modules/casino/store/actions/profile';

//import './index.scss';

type TemplateProps = {
  children: any;
  styleText: string;
  className: string;
  properties?: any;
};

const ModuleElementDiv = styled.div<{ $styleText: string }>((props) => props.$styleText);

const MobileApps = (componentProps: TemplateProps) => {
  // let props = componentProps;

  const client_player_id = useAppSelector((state) => state.profile.client_player_id);
  const [isModalOpen, setIsModalOpen] = React.useState<boolean>(false);

  const dispatch = useAppDispatch();

  React.useEffect(() => {
    GTMEvent({ event: 'mobile_apps_loaded', os: os.name });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const GTMEvent = React.useCallback((payload: { event: string; os: string }) => {
    // @ts-ignore
    if (!window.dataLayer) {
      return;
    }
    // Push data to GTM
    // @ts-ignore
    window.dataLayer.push(payload);
  }, []);

  const os = React.useMemo(() => {
    return ClientDetection.getOS();
  }, []);

  const connectApp = React.useCallback(() => {
    GTMEvent({ event: 'mobile_apps_connect_button', os: os.name });
    dispatch(connectAppNotification());
    setIsModalOpen(true);
  }, [GTMEvent, dispatch, os.name]);

  const isAndroid = React.useMemo(() => {
    return os.name === 'android';
  }, [os.name]);

  const isIOS = React.useMemo(() => {
    return os.name === 'iOS';
  }, [os.name]);

  const isHuawei = React.useMemo(() => {
    return ClientDetection.isHuawei();
  }, []);

  const isUnknown = React.useMemo(() => {
    return !isAndroid && !isIOS && !isHuawei;
  }, [isAndroid, isHuawei, isIOS]);

  const isDisabledConnectApp = React.useMemo(() => {
    return !client_player_id || isUnknown;
  }, [client_player_id, isUnknown]);

  const toggleModal = React.useCallback(() => {
    setIsModalOpen((prev) => !prev);
  }, []);

  const contextValue = React.useMemo(() => {
    return {
      isDisabledConnectApp,
      connectApp,
      isAndroid,
      isHuawei,
      isIOS,
      isUnknown,
      isModalOpen,
      toggleModal,
    };
    // }, [dataElementContext, componentProps]);
  }, [connectApp, isAndroid, isDisabledConnectApp, isHuawei, isIOS, isModalOpen, isUnknown, toggleModal]);

  return (
    <ModuleElementDiv className={componentProps.className ?? ''} $styleText={componentProps.styleText}>
      <DataElementContext.Provider value={contextValue}>{componentProps.children}</DataElementContext.Provider>
    </ModuleElementDiv>
  );
};

export default MobileApps;
